export const ANNOUNCEMENT_ID = "vigo-7th-anniversary";
export const ANNOUNCEMENT_POPUP_IMAGE_URL =
    "https://vigo-public.s3.eu-west-1.amazonaws.com/mp-popup.png";
export const ANNOUNCEMENT_BANNER_IMAGE_URL =
    "https://vigo-public.s3.eu-west-1.amazonaws.com/mp-alert.png";
